import React from 'react';

/**
 * Small, optimized SVG glyph for male gender
 * Red-700 color (#b91c1c), minimal size for fast loading
 * Features: Male face with short hair
 */
export const MaleGlyph = ({ className = '', size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Male"
    >
      <circle cx="8" cy="8" r="7" fill="#b91c1c" />
      {/* Face */}
      <ellipse cx="8" cy="9" rx="3.5" ry="4" fill="white" />
      
      {/* Short hair on top and sides */}
      <path
        d="M4.5 4.5 Q5 3 6 3.5 Q7 4 8 3.5 Q9 4 10 3.5 Q11 3 11.5 4.5 Q11.8 5.5 11.5 6.5 Q11 8 8 8 Q5 8 4.5 6.5 Q4.2 5.5 4.5 4.5 Z"
        fill="white"
      />
      {/* Hair detail lines */}
      <path
        d="M5.5 4.5 Q6.5 3.8 8 3.8 Q9.5 3.8 10.5 4.5"
        stroke="#b91c1c"
        strokeWidth="0.4"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Eyes */}
      <ellipse cx="6.5" cy="8.5" rx="0.7" ry="0.6" fill="#b91c1c" />
      <ellipse cx="9.5" cy="8.5" rx="0.7" ry="0.6" fill="#b91c1c" />
      
      {/* Eyebrows - friendly, slightly curved up */}
      <path
        d="M5.5 7.5 Q6.5 7 7.5 7.3 M8.5 7.3 Q9.5 7 10.5 7.5"
        stroke="#b91c1c"
        strokeWidth="0.8"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Nose */}
      <path
        d="M8 9.5 L7.5 11 L8.5 11 Z"
        fill="#b91c1c"
      />
      
      {/* Mouth - friendly smile */}
      <path
        d="M6.5 11.5 Q8 12.5 9.5 11.5"
        stroke="#b91c1c"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

/**
 * Small, optimized SVG glyph for female gender
 * Red-700 color (#b91c1c), minimal size for fast loading
 * Features: Female face with long hair and makeup
 */
export const FemaleGlyph = ({ className = '', size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Female"
    >
      <circle cx="8" cy="8" r="7" fill="#b91c1c" />
      {/* Face - more rounded and softer */}
      <ellipse cx="8" cy="9" rx="3.2" ry="3.8" fill="white" />
      
      {/* Long hair on sides and top */}
      <path
        d="M3.5 4 Q4 2.5 6 3 Q7.5 3.5 8 3 Q8.5 3.5 10 3 Q12 2.5 12.5 4 Q13 5.5 12.5 7 Q12 9 8 9 Q4 9 3.5 7 Q3 5.5 3.5 4 Z"
        fill="white"
      />
      {/* Hair flowing down sides */}
      <path
        d="M3.5 7 Q3.8 9.5 4 11.5 M12.5 7 Q12.2 9.5 12 11.5"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Hair detail/parting */}
      <path
        d="M5 4.5 Q6.5 3.5 8 3.5 Q9.5 3.5 11 4.5"
        stroke="#b91c1c"
        strokeWidth="0.3"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Eyes - larger with makeup, happy/curved shape */}
      <ellipse cx="6.5" cy="8.5" rx="0.8" ry="0.7" fill="#b91c1c" />
      <ellipse cx="9.5" cy="8.5" rx="0.8" ry="0.7" fill="#b91c1c" />
      {/* Eyeliner/makeup effect - curved up for happy look */}
      <path
        d="M5.5 8.2 Q6.5 7.5 7.5 8.2 M8.5 8.2 Q9.5 7.5 10.5 8.2"
        stroke="#b91c1c"
        strokeWidth="0.6"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Eyebrows - friendly arched, curved up */}
      <path
        d="M5.5 7.3 Q6.5 6.5 7.5 7.3 M8.5 7.3 Q9.5 6.5 10.5 7.3"
        stroke="#b91c1c"
        strokeWidth="0.7"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Nose - smaller and more delicate */}
      <path
        d="M8 9.5 L7.7 10.5 L8.3 10.5 Z"
        fill="#b91c1c"
      />
      
      {/* Mouth - big friendly smile with lipstick effect */}
      <path
        d="M6 11 Q8 12.5 10 11"
        stroke="#b91c1c"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Lip highlight for smile */}
      <path
        d="M6.5 11.2 Q8 12 9.5 11.2"
        stroke="white"
        strokeWidth="0.4"
        strokeLinecap="round"
        fill="none"
        opacity="0.7"
      />
    </svg>
  );
};

